import { QUESTIONNAIRE_EVALUATION as MODULE_PREFIX } from '../constants';
export const QUESTIONNAIRE_EVALUATION_GET_EVALUATION_ID_BY_EXTERNAL_EVAL_ID_REQUEST = `${MODULE_PREFIX}_GET_EVALUATION_ID_BY_EXTERNAL_EVAL_ID_REQUEST`;
export const QUESTIONNAIRE_EVALUATION_GET_EVALUATION_ID_BY_EXTERNAL_EVAL_ID_SUCCESS = `${MODULE_PREFIX}_GET_EVALUATION_ID_BY_EXTERNAL_EVAL_ID_SUCCESS`;
export const questionnaireEvaluationGetEvaluationIdByExternalEvalIdAction = (requestData) => ({
    type: QUESTIONNAIRE_EVALUATION_GET_EVALUATION_ID_BY_EXTERNAL_EVAL_ID_REQUEST,
    payload: requestData
});
export const questionnaireEvaluationGetEvaluationIdByExternalEvalIdSuccessAction = (evaluationId) => ({
    type: QUESTIONNAIRE_EVALUATION_GET_EVALUATION_ID_BY_EXTERNAL_EVAL_ID_SUCCESS,
    payload: evaluationId
});
//# sourceMappingURL=questionnaireEvaluationGetEvalIdByExternalEvalIdActions.js.map